import ReactDOM from "react-dom";
import TagManager from "react-gtm-module";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "./index.scss";
import * as serviceWorker from "./serviceWorker";

import * as Sentry from "@sentry/react";

// TODO(COACH-1866): remove after verifying env injection in dev/staging
console.log("[env-audit] REACT_APP_* injected values:", {
  REACT_APP_ENV: process.env.REACT_APP_ENV,
  REACT_APP_BASE_URL: process.env.REACT_APP_BASE_URL,
  REACT_APP_COACHING_WEB_API: process.env.REACT_APP_COACHING_WEB_API,
  REACT_APP_COACHING_SCORECARD_API:
    process.env.REACT_APP_COACHING_SCORECARD_API,
  REACT_APP_COACHING_WEB_DEBUGGER: process.env.REACT_APP_COACHING_WEB_DEBUGGER,
  REACT_APP_GTM_ID: process.env.REACT_APP_GTM_ID,
  REACT_APP_GLITCHTIP_DSN_FE: process.env.REACT_APP_GLITCHTIP_DSN_FE,
  REACT_APP_RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  REACT_APP_MAINTENANCE_MODE: process.env.REACT_APP_MAINTENANCE_MODE,
  REACT_APP_SHOW_MAINTENANCE_BANNER:
    process.env.REACT_APP_SHOW_MAINTENANCE_BANNER,
  REACT_APP_MAINTENANCE_BANNER_TEXT:
    process.env.REACT_APP_MAINTENANCE_BANNER_TEXT,
  NODE_ENV: process.env.NODE_ENV,
});

Sentry.init({
  environment: process.env.REACT_APP_ENV,
  dsn: process.env.REACT_APP_GLITCHTIP_DSN_FE,
  enabled:
    process.env.REACT_APP_ENV === "production" ||
    process.env.REACT_APP_ENV === "staging",
  integrations: [
    Sentry.browserTracingIntegration(),
    //GlitchTip does not support this//
    // Sentry.replayIntegration({
    //   maskAllText: false,
    //   blockAllMedia: false,
    // }),
  ],
  // Performance Monitoring
  tracesSampleRate: 0.1, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    process.env.REACT_APP_BASE_URL,
    process.env.REACT_APP_COACHING_WEB_API,
    process.env.REACT_APP_COACHING_SCORECARD_API,
  ],
  //GlitchTip does not support this//
  // Session Replay
  // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

if (process.env.REACT_APP_ENV === "production") {
  TagManager.initialize({ gtmId: process.env.REACT_APP_GTM_ID });
}

// Wait for DOM to be ready, helps with Rocket Loader/Cloudflare
document.addEventListener("DOMContentLoaded", () => {
  const rootEl = document.getElementById("root");
  if (rootEl) {
    ReactDOM.render(
      <Router>
        <App />
      </Router>,
      rootEl
    );
  }
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
